import { readThemeMode, resolveThemeMode } from './themeBootstrapRuntime';

/**
 * Safari/WebKit does not reliably resample temporary meta/root-theme changes
 * for browser UI during SPA presentation changes. Video owns only its fixed
 * black surface there. Android Chromium remains the dynamic theme-color path.
 */
export function applyVideoBrowserChrome(doc: Document = document): void {
	if (!isAndroidChromium(doc)) return;
	findOrCreateThemeColor(doc).content = '#000000';
}

/** Recompute Android chrome from the current app theme, never a stale video-open snapshot. */
export function restoreVideoBrowserChrome(doc: Document = document): void {
	if (!isAndroidChromium(doc)) return;
	const mode = readThemeMode();
	const background = resolveThemeMode(mode).background;
	if (background) findOrCreateThemeColor(doc).content = background;
}

function isAndroidChromium(doc: Document): boolean {
	const ua = doc.defaultView?.navigator.userAgent ?? (typeof navigator === 'undefined' ? '' : navigator.userAgent);
	return /Android/i.test(ua) && /(?:Chrome|Chromium|CriOS|EdgA|SamsungBrowser|wv)/i.test(ua);
}

function findOrCreateThemeColor(doc: Document): HTMLMetaElement {
	const existing = doc.head.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
	if (existing) return existing;
	const meta = doc.createElement('meta');
	meta.name = 'theme-color';
	doc.head.appendChild(meta);
	return meta;
}
